import React from 'react'
import Bredcom from '../Bredcom/Main' 
import Header from '../headerone/Main' 


 
function InternalComplaintsCommittee() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="Internal Complaints Committee" />
        <section className="project-detail">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="text-column col-lg-12 col-md-12 col-sm-12">                               
                                <div className="inner-column">
                                    <h2>Internal Complaints Committee</h2>
                                    <table className="table table-bordered mb-40">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Yogendra Singh</td>
                                                <td>Chairmain</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Ms. Geeta Sharma</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Dr. Tarun Virmani</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Ms. Sakshi Garg</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Mr. Ashutosh Kumar</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Ms. Ritika Jaggi</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Ms. Shilpa Sharma (L.L.B)</td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Mr. Harshit (BBA)</td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>Registrar</td>
                                                <td>Member Secretary</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        
    </> 
  ) 
} 
 
export default InternalComplaintsCommittee 